<template>
  <div>
    <FormContainer>
      <form class="border p-8 rounded shadow-2xl" @submit="handleSubmit">
        <div class="mb-3">
          <label class="form-label form-required"> Vimeo URL </label>
          <input
            type="url"
            v-model="form.link"
            class="form-input"
            placeholder="URL of video"
            required
          />
        </div>
        <div class="mb-3">
          <label class="form-label form-required"> Title </label>
          <input
            type="text"
            v-model="form.title"
            class="form-input"
            placeholder="Title of video"
            required
          />
        </div>
        <div class="mb-3">
          <label class="form-label"> Description </label>
          <input
            type="text"
            v-model="form.description"
            class="form-input"
            placeholder="Description of video"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Display on news page</label>
          <div class="form-input space-x-3">
            <span>Featured</span>
            <input
              class="cursor-pointer"
              type="checkbox"
              v-model="form.featured"
            />
          </div>
        </div>

        <div class="border-t-2 my-5"></div>

        <p class="text-lg mb-3">For ShotTrackers home page (slider):</p>

        <div>
          <label class="form-label">Display on slider</label>
          <div class="form-input space-x-3">
            <span>Featured</span>
            <input
              class="cursor-pointer"
              type="checkbox"
              v-model="form.homeFeatured"
            />
          </div>
        </div>

        <button class="mt-4 py-2 px-3 bg-STblue text-white w-full rounded">
          Submit
        </button>
      </form>

      <VideoPreview :form="form" />
    </FormContainer>
  </div>
</template>

<script>
import VideoPreview from "./VideoPreview.vue";
import FormContainer from "../../FormContainer.vue";

export default {
  name: "VideoForm",

  props: {
    form: Object,
  },

  components: {
    VideoPreview,
    FormContainer,
  },

  methods: {
    async handleSubmit(e) {
      e.preventDefault();

      this.$emit("handleSubmit");
    },
  },
};
</script>
